import { useState, useEffect } from "react";
import { addToCartOrQuote } from "../../actions/cartActions";
import { setSelectedCartOrQuotes } from "../../actions/configActions";
import { useSelector, useDispatch } from "react-redux";
import { Button, toBoolean } from "@ten24/slatwall-storefront-react-private/global";
import { AddProductToQuoteModal } from "../ProductDetail/AddProductToQuoteModal";
import { useTranslation } from "react-i18next";
import { setAllCartOrQuotes } from "../../actions/cartActions";

const CART_ID = "cart-collapseOne";

const DraftCartQuotes = ({
  sku = "",
  quantity,
  classList = "accordion-item quote-input-box",
  isLoading = false,
  isDisabled = false,
}) => {
  const dispatch = useDispatch();
  const selectedCartOrQuote = useSelector((state) => state.cartQuoteReducer);
  const { t } = useTranslation();
  const [quoteModal, setQuoteModal] = useState(false);
  const cartAndQuotes = useSelector((state) => state?.allCartQuote?.cartAndQuote);

  useEffect(() => {
    dispatch(setAllCartOrQuotes());
  }, [dispatch]);

  return (
    <>
      {quoteModal && (
        <AddProductToQuoteModal show skuID={sku?.skuID || ""} setQuoteModal={setQuoteModal} quantity={quantity} />
      )}
      <div className={classList}>
        <div className="d-flex col-12">
          <Button
            classList="btn btn-primary col-10"
            isLoading={isLoading}
            disabled={
              selectedCartOrQuote?.quoteName &&
              (!toBoolean(sku?.settings?.skuAllowQuoteFlag) || isDisabled || quantity < 1)
            }
            onClick={(e) => {
              e.preventDefault();
              dispatch(
                addToCartOrQuote(sku.skuID, quantity, selectedCartOrQuote?.orderID, selectedCartOrQuote?.quoteName)
              ).then(() => {
                dispatch(setAllCartOrQuotes());
              });
            }}
          >
            {selectedCartOrQuote?.orderID
              ? `${t("frontend.quote.addToQuote")} ${selectedCartOrQuote?.quoteName || ""}`
              : t("frontend.product.add_to_cart")}
          </Button>
          <button
            className="accordion-button collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#${CART_ID}`}
            aria-expanded="false"
            aria-controls={CART_ID}
          ></button>
        </div>
        <div
          id={CART_ID}
          className="accordion-collapse accordion-absolute collapse"
          aria-labelledby="cart-headingOne"
          data-bs-parent="#accordioncartExample"
        >
          <div className="accordion-body">
            <div className="d-flex justify-content-end">
              <span className="text-primary" onClick={() => setQuoteModal(true)} role="button">
                Add To New Quote
              </span>
            </div>

            {cartAndQuotes?.length > 0 &&
              cartAndQuotes.map((order) => {
                return (
                  <div className="d-flex col-12 mt-2 justify-content-between" key={order?.orderID}>
                    <b
                      role="button"
                      className="col-6"
                      onClick={() => {
                        if (order.orderTypeCode === "otSalesOrder") dispatch(setSelectedCartOrQuotes({}));
                        else
                          dispatch(
                            setSelectedCartOrQuotes({
                              orderID: order.orderID,
                              quoteName: order.quoteName,
                            })
                          );
                      }}
                    >
                      {order.orderTypeCode === "otSalesOrder" ? "Shopping cart" : order?.quoteName}
                    </b>

                    <span className="col-6">
                      {order?.totalItems > 1 ? `${order?.totalItems} Items` : `${order?.totalItems || 0} Item`}
                    </span>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export { DraftCartQuotes };
